import React, {useEffect, useState} from 'react';

import Announcements from './Announcements';
import Drawer from 'components/Drawer/Drawer';

import {UncontrolledTooltip} from 'reactstrap';

import styles from './PrivateNavAnnouncements.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';

function PrivateNavAnnouncements() {
  const [isOpen, setIsOpen] = useState(false);
  const [direction, setDirection] = useState();
  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    const updateSrc = () => {
      if (window.innerWidth >= 1024) {
        setDirection('right');
      } else {
        setDirection('bottom');
      }
    };

    updateSrc();
    window.addEventListener('resize', updateSrc);
    return () => window.removeEventListener('resize', updateSrc);
  }, []);

  return (
    <>
      <div className={styles['announcements']}>
        <MuiIcon
          name="campaign"
          variant="outlined"
          style={{cursor: 'pointer', fontSize: '1.25rem'}}
          onClick={toggle}
          id="whats-new"
        />
      </div>

      {!isOpen && (
        <UncontrolledTooltip target="whats-new">
          Product Updates
        </UncontrolledTooltip>
      )}

      <Drawer isOpen={isOpen} direction={direction} toggle={toggle}>
        <Announcements toggle={toggle} isOpen={isOpen} />
      </Drawer>
    </>
  );
}

export default PrivateNavAnnouncements;
